/* eslint-disable no-magic-numbers */
import { z as zod } from 'zod'
import phone from "phone"
import i18next from 'i18next'

const phoneNumber = zod
    .string()
    .min(8, `Must be 8 digits`)
    .max(8, `Must be 8 digits only`)
    .refine(input => {
        const phoneNumberValidation = phone(input, { country: `SG` })
        return phoneNumberValidation.isValid
    }, { message: i18next.t(`common_validation_error_phone_number`) })

const myEmail = zod.string()
    .email(`This is not a valid email.`)

const recipientEmail = zod.string()
    .email(`This is not a valid email.`)

const myName = zod
    .string()

const nricLastFourCharacters = zod.string().regex(/^\d{3}[A-Za-z]$/, {
    message: `The string must be 4 characters long, starting with 3 digits and ending with a letter.`,
})

const recipientName = zod
    .string()

const unionMemberReferralCode = zod.preprocess(
    input => input === `` ? undefined : input,
    zod
        .string()
        .regex(/^[A-Z0-9]{12}$/, `Referral code must be 12 characters long and contain only letters and numbers`)
        .optional(),
)

const SUBSCRIPTION_GIFT_FORM = {
    phoneNumber,
    myEmail,
    myName,
    recipientName,
    recipientEmail,
    unionMemberReferralCode,
    nricLastFourCharacters,
}

export default SUBSCRIPTION_GIFT_FORM